/*
  We toggle the portfolio subdomain when navigating in and out of porfolio pages.
  This function handles the different scenarios.
*/

import env from '../../utils/env';

const resolveSubdomains = (portfolioName:string|null, targetPath:string, useSubdomain:boolean) => {
  const envLocation = env();
  if (envLocation.portfolioName) {
    if (useSubdomain) return targetPath;
    const { protocol } = window.location;
    return `${protocol}//${envLocation.hostWithoutPortfolioName}${targetPath}`;
  }

  if (useSubdomain) {
    const { host, protocol } = window.location;
    return `${protocol}//${portfolioName}.${host}`;
  }
  return targetPath;
};

export default resolveSubdomains;
